import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {LogoPath} from '../../../core/constants/image';
import { LoginLink } from '../../../core/constants/common';

@Component({
  selector: 'school-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  loginForm: FormGroup;

  logopath: string = LogoPath;
  copyyear: any = (new Date()).getFullYear();

  constructor(private router: Router) { }

  ngOnInit(): void {
    if(this.router.url == '/'){
      this.router.navigate([LoginLink]);
    }
  }

}
